import React from 'react'
import { Box, FormControl, IconButton, InputLabel, MenuItem, Select, Tooltip, Typography } from '@mui/material'
import { StarBorderRounded, StarRounded } from '@mui/icons-material'
import { useSmartTranslation } from '../../hooks/useSmartTranslation'
import PrinterStatusChip from './PrinterStatusChip'
import { labelSizeText } from './labelPrintingTexts'

// Historia 226 (S124-S126, S143): the QR dialog's printer selector. It receives only the ACTIVE printers (RN5); an
// unavailable one is still offered with its chip (RN32). `printerId` is '' when none is chosen.
const QrPrinterSelect = ({ printers, printerId, defaultId = '', onChange, onMakeDefault }) => {
  const { t_ } = useSmartTranslation()
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <FormControl size='small' sx={{ minWidth: 280 }}>
        <InputLabel id='qr-label-printer'>{t_('Printer')}</InputLabel>
        <Select
          labelId='qr-label-printer'
          label={t_('Printer')}
          value={printerId}
          onChange={(event) => onChange(event.target.value)}
        >
          {printers.map((printer) => (
            <MenuItem key={printer.id} value={printer.id}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                <Typography sx={{ flex: 1 }}>{printer.name}</Typography>
                <Typography sx={{ fontSize: 13, color: 'text.secondary' }}>{labelSizeText(printer)}</Typography>
                <PrinterStatusChip
                  availability={printer.availability}
                  availabilityReason={printer.availabilityReason || ''}
                  availabilityProblems={printer.availabilityProblems || []}
                />
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Tooltip title={t_('Use as default')}>
        <span>
          <IconButton aria-label={t_('Use as default')} size='small' disabled={printerId === ''} onClick={() => onMakeDefault(printerId)}>
            {printerId !== '' && printerId === defaultId ? <StarRounded color='warning' /> : <StarBorderRounded />}
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  )
}

export default QrPrinterSelect
